// so far only the 404 page doesn't display the header
export default (routeName): boolean =>
  routeName !== '404' && routeName !== 'home';
